import React from 'react';

import { SortSelect } from '@/components/SortSelect';
import {
  getCurrentSort,
  setCurrentSort,
  setPage,
} from '@/store/reducers/cars-stock';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import { OptionType } from '@/typings/common';
import { useStockCarsSelectOptions } from '@/modules/CarsStock/components/common.hooks';

import { SortingProps } from './types';

function Sorting({ carsType }: SortingProps) {
  const dispatch = useTypedDispatch();
  const currentSort = useTypedSelector(getCurrentSort);
  const options = useStockCarsSelectOptions(carsType);

  const handleChangeSort = (newSort: OptionType) => {
    dispatch(setCurrentSort(newSort));
    dispatch(setPage(1));
  };

  return (
    <SortSelect
      value={currentSort}
      options={options}
      onChange={handleChangeSort}
    />
  );
}

export default Sorting;
